import { gql } from '@apollo/client';
import type {
  MissionLockedReasonsFragment,
  MissionRewardsFragment,
} from '../../../../models/__generated__/graphql.js';
import { BADGE_BASICS } from '../badge';

export const MISSION_REWARDS = gql`
  fragment MissionRewards on Mission {
    id

    rewards {
      __typename
      ... on Badge {
        ...BadgeBasics
        expiresAt
        limitAmount
        limitDays
        outOfStock
        spent
      }
      ... on Point {
        count
        category
        expiresAt
        limitAmount
        limitDays
        outOfStock
        spent
      }
      ... on Sweepstake {
        count
        category
        expiresAt
        limitAmount
        limitDays
        outOfStock
        spent
      }
    }
  }

  ${BADGE_BASICS}
`;

export type Reward = NonNullable<MissionRewardsFragment['rewards']>[number];

export const MISSION_LOCKED_REASONS = gql`
  fragment MissionLockedReasons on Mission {
    id

    lockedStatus {
      __typename
      locked
      reasons {
        __typename
        ... on MultipleReasons {
          operator
          reasons {
            __typename
            ... on PrerequisiteLevelReason {
              label
              id
              name
            }
            ... on PrerequisiteMissionReason {
              label
              id
              name
            }
            ... on StartTimeReason {
              label
              startTime
            }
            ... on UnknownReason {
              label
              reasonDetails
            }
          }
        }
        ... on PrerequisiteLevelReason {
          label
          name
        }
        ... on PrerequisiteMissionReason {
          label
          id
          name
        }
        ... on StartTimeReason {
          label
          startTime
        }
        ... on UnknownReason {
          label
          reasonDetails
        }
      }
    }
  }
`;

export type MissionLockedStatus = NonNullable<
  MissionLockedReasonsFragment['lockedStatus']
>;

export type MissionLockedReason = NonNullable<MissionLockedStatus['reasons']>;

export const MISSION_TASKS = gql`
  fragment MissionTasks on Mission {
    id

    tasks {
      __typename
      ... on ClickableLink {
        actionName
        displayText
        url
        completed
      }
      ... on ExternalTask {
        displayText
        completed
      }
      ... on Video {
        actionName
        displayText
        url
        completed
      }
      ... on Quiz {
        displayText
        token
        server
        userId
        quizId
        completed
      }
    }
  }
`;
